import { useSelector, useDispatch } from 'react-redux';
import { addFavoriteBrand, removeFavoriteBrand } from '../actions/favoritesActions';
import {
    add, remove, sendToComponent, storeInCache
} from '../helpers/favoriteBrand';

export function useFavoritesBrands() {
    const dispatch = useDispatch();
    const { brands: favoriteBrands } = useSelector(({ favorites }) => favorites);

    const isFavorite = (gender, brandAzId) => {
        if (favoriteBrands && typeof favoriteBrands[gender] !== 'undefined') {
            return favoriteBrands[gender].some(brand => brand.brand_az_id === brandAzId);
        }

        return false;
    };

    const afterAction = (id) => {
        storeInCache(id);

        sendToComponent('FiltersListItem', {
            isFavorite,
            id
        });
    };

    const addToFavorites = async (id, gender, name, brandAzId) => {
        await add(id, gender, name, brandAzId);
        const payload = {
            brand: {
                id,
                gender,
                name,
                brand_az_id: brandAzId
            }
        };
        dispatch(addFavoriteBrand(payload));
        afterAction(id);
    };

    const removeFromFavorites = async (id, gender, name, brandAzId) => {
        await remove(id, gender, name, brandAzId);
        const payload = {
            brand: {
                id,
                gender,
                name,
                brand_az_id: brandAzId
            }
        };
        dispatch(removeFavoriteBrand(payload));
        afterAction(id);
    };

    return { isFavorite, addToFavorites, removeFromFavorites };
}
